import React, { FunctionComponent } from 'react'
import { Divider, Grid } from '@material-ui/core'
import { Subtitle, Title } from '../../../styles'
import Form from 'shared/components/Form'
import { colors } from 'shared/styles/colors'
import RadioButton from 'shared/components/Radio'
import LTDA from '../../../components/LTDA'
import SA from '../../../components/SA'
import FundoDeInvestimento from './components/FundoDeInvestimento'
import ENaturezaJuridica from 'modules/pagamentos/domain/entities/ENaturezaJuridica'
import { useOnboarding } from 'modules/pagamentos/hooks/useOnboarding'

const DadosControladora: FunctionComponent = () => {
  const {
    naturezaJuridicaEmpresaControlada,
    setNaturezaJuridicaEmpresaControlada,
  } = useOnboarding()

  return (
    <>
      <Divider style={{ margin: '32px 0' }} />
      <Grid container>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Title>Dados da controladora</Title>
          <Subtitle>
            Informe os dados da empresa que controla a sua empresa.
          </Subtitle>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <Title>Tipo de empresa</Title>
          <Subtitle>Selecione a natureza legal da controladora</Subtitle>
          <Form
            onSubmit={undefined}
            initialValues={{
              naturezaJuridicaEmpresaControlada: ENaturezaJuridica.LTDA,
            }}
            validationSchema={() => ({})}
          >
            {formControl => (
              <Grid container>
                <Grid
                  container
                  justifyContent="space-between"
                  style={{ margin: '8px 0' }}
                >
                  <Grid container spacing={3}>
                    <Grid item>
                      <RadioButton
                        id={ENaturezaJuridica.LTDA}
                        label={ENaturezaJuridica.LTDA}
                        name="naturezaJuridicaEmpresaControlada"
                        value={ENaturezaJuridica.LTDA}
                        onChange={() =>
                          setNaturezaJuridicaEmpresaControlada(
                            ENaturezaJuridica.LTDA,
                          )
                        }
                        borderColor={colors.green}
                        indicatorColor={colors.green}
                        checked={
                          naturezaJuridicaEmpresaControlada ===
                          ENaturezaJuridica.LTDA
                        }
                      />
                    </Grid>
                    <Grid item>
                      <Grid item xs={12}>
                        <RadioButton
                          id={ENaturezaJuridica.SA}
                          label={ENaturezaJuridica.SA}
                          name="naturezaJuridicaEmpresaControlada"
                          value={ENaturezaJuridica.SA}
                          onChange={() =>
                            setNaturezaJuridicaEmpresaControlada(
                              ENaturezaJuridica.SA,
                            )
                          }
                          borderColor={colors.green}
                          indicatorColor={colors.green}
                          checked={
                            naturezaJuridicaEmpresaControlada ===
                            ENaturezaJuridica.SA
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Grid item xs={12}>
                        <RadioButton
                          id={ENaturezaJuridica.FundoDeInvestimento}
                          label="Fundo de investimento"
                          name="naturezaJuridicaEmpresaControlada"
                          value={ENaturezaJuridica.FundoDeInvestimento}
                          onChange={() =>
                            setNaturezaJuridicaEmpresaControlada(
                              ENaturezaJuridica.FundoDeInvestimento,
                            )
                          }
                          borderColor={colors.green}
                          indicatorColor={colors.green}
                          checked={
                            naturezaJuridicaEmpresaControlada ===
                            ENaturezaJuridica.FundoDeInvestimento
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Form>

          {naturezaJuridicaEmpresaControlada === ENaturezaJuridica.LTDA && (
            <LTDA empresaControladora={true} />
          )}
          {naturezaJuridicaEmpresaControlada === ENaturezaJuridica.SA && (
            <SA empresaControladora={true} />
          )}
          {naturezaJuridicaEmpresaControlada ===
            ENaturezaJuridica.FundoDeInvestimento && (
            <FundoDeInvestimento empresaControladora={true} />
          )}
        </Grid>
      </Grid>
      <Divider style={{ margin: '32px 0' }} />
    </>
  )
}

export default DadosControladora
